<template>
  <div id="sig-container" class="block full form-horizontal">
    <div class="loader" v-if="loading">
      <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
    </div>
    <div class="widget">
      <div class="
          widget-content widget-content-mini
          themed-background-dark-default
          text-light
        ">
        <span class="float-right text-muted">
          <button type="button" @click="$router.go(-1)" class="btn btn-xs btn-primary">
            Volver
          </button>
        </span>
        Informe gestiones
      </div>
      <div class="widget-content border-bottom themed-background-muted text-center">
        <div class="container">
          <div class="form-group text-center">
            <label class="control-label col-lg-3 col-md-2" v-text="'Fecha gestión'"></label>
            <div class="col-lg-12 col-md-12">
              <date-picker id="datepicker" v-model="params.fecha_inicio" :placeholder="'Fecha inicio'"
                :bootstrap-styling="true" :clear-button="true" format="yyyy-MM-dd" :language="es"></date-picker>
              <p id="space">
                <date-picker id="datepicker" v-model="params.fecha_fin" :placeholder="'Fecha fin'"
                  :bootstrap-styling="true" :clear-button="true" format="yyyy-MM-dd" :language="es"></date-picker>
              </p>
            </div>
          </div>
          <div class="form-group">
            <label class="control-label col-lg-3 col-md-2" v-text="'Asesor'"></label>
            <div class="col-lg-12 col-md-12">
              <select class="form-control" id="datos_usuarios" v-model="params.usuario_id">
                <option :value="null">Seleccione el asesor</option>
                <option v-for="usuario in usuarios" :key="usuario.id" :value="usuario.id">
                  {{
                    usuario.nombres
                      ? usuario.nombres
                      : null + usuario.apellidos
                        ? usuario.apellidos
                        : null
                  }}
                </option>
              </select>
            </div>
            <label class="control-label col-lg-3 col-md-2" v-text="'Sub tipo gestión'"></label>
            <div class="col-lg-12 col-md-12">
              <select class="form-control" id="datos_sub_tipos" v-model="params.sub_tipo_gestion">
                <option :value="null">Seleccione el sub tipo de gestión</option>
                <option v-for="sub_tipo in this.sub_tipos" :key="sub_tipo.id" :value="sub_tipo.id">
                  {{ sub_tipo.descripcion ? sub_tipo.descripcion : null }}
                </option>
              </select>
            </div>
            <label class="control-label col-lg-3 col-md-2" v-text="'Casa cobranza'"></label>
            <div class="col-lg-12 col-md-12">
              <select class="form-control" id="casa" v-model="params.casa_cobranza">
                <option :value="null">Seleccione la casa de cobranza</option>
                <option v-for="casa in casas" :key="casa.nit" :value="casa.nit">
                  {{ casa.nombre ? casa.nombre : null }}
                </option>
              </select>
            </div>
            <label class="control-label col-lg-3 col-md-2" v-text="'cédula deudor'"></label>
            <div class="col-lg-12 col-md-12">
              <input type="text" id="cedula_deudor" v-model.trim="params.deudor" class="form-control"
                placeholder="# cedula del deudor">
            </div>
          </div>

          <div class="form-actions">
            <button class="btn btn-primary mr-3" @click="solicitarInforme()">
              solicitar Informe</button>
            <button class="btn btn-primary ml-3" @click="getInformes()">
              refrescar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="loader" v-if="loading">
        <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
      </div>
      <table-component :data="datos" @click-event="clickEvent">
        <table-column slot="label" :label="'Archivo'" v-bind:value="'nombre'"></table-column>
        <table-column slot="label" :label="'Fecha solicitud'" v-bind:value="'fecha_solicitud'"></table-column>
        <table-column slot="label" :label="'Estado'" v-bind:value="'estado'"></table-column>
        <table-column slot="label" :label="'Acciones'" :icon="'fa'">
          <template slot="icon" :icon="'far fa-arrow-alt-circle-down'" :class="'btn btn-sm btn-primary'"
            :slug="'descargar-informe'"></template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";

export default {
  name: "Gestiones",
  data: () => {
    return {
      params: {
        usuario_id: null,
        fecha_inicio: null,
        fecha_fin: null,
        sub_tipo_gestion: null,
        casas: null,
        deudor: null,
        paginar: "false",
        page: 1,
      },
      datos: [],
      sub_tipos: {},
      es: es,
      errors: null,
    };
  },
  components: {
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn"),
    "date-picker": Datepicker,
  },
  computed: {
    ...mapGetters({ loading: "loading" }),
    usuarios() {
      return this.$store.getters["user/usuarios"];
    },
    casas() {
      return this.$store.getters["casascobranza/casas"];
    },
  },
  methods: {
    getInformes() {
      this.datos = [];
      this.$store.dispatch("index", {
        endpoint: "informes/informe-gestion-generar",
        params: this.params,
      })
        .then((response) => {
          this.datos = response;
        })
        .catch((error) => {
          this.errors = error.data.errors;
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "Se ha presentado un error realizando su consulta",
          });
        });
    },
    descargarArchivo(id) {
      this.$store.dispatch("index", {
        endpoint: "informes/informe-gestion-descargar",
        params: { "id": id },
      })
        .then((response) => {
          console.log(response);
          window.location.href = `${response}`;
        })
        .catch((error) => {
          this.errors = error.data.errors;
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "Se ha presentado un error al descargar el archivo",
          });
        });
    },
    solicitarInforme() {
      this.$store.dispatch("store", {
        endpoint: "informes/informe-gestion-generar",
        params: this.params,
      })
        .then((response) => {
          this.$notify({
            title: "Solicitud de informe!",
            type: "success",
            content: "Se ha solicitado la generacion del informe. pronto recibiras un correo notificando de la creacion del informe.",
          });
          this.getInformes();
        })
        .catch((error) => {
          this.errors = error.data.errors;
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "Se ha presentado un error al solicitar el informe",
          });
        });
    },
    clickEvent(data, slug) {
      switch (slug) {
        case "descargar-informe":
          this.descargarArchivo(data.id);
          break;
      }
    },
  },
  mounted() {
    //Consulta de asesores
    this.$store.dispatch("user/fetchUsuarios", {
      endpoint: "usuario",
      params: { paginar: false, casa_cobranza: 1, asesores: "true" },
    });

    //Consulta de casas de cobranza
    this.$store.dispatch("casascobranza/fetch", {
      endpoint: "administracion/casascobranza",
      params: {
        paginar: "false",
      },
    });
    //Consultar sub_tipo de gestion
    this.$store
      .dispatch("index", {
        endpoint: "subtipo_gestion",
        params: { paginar: false },
      })
      .then((response) => {
        this.sub_tipos = response.datos;
      })
      .catch((error) => {
        this.errors = error.data.errors;
        this.$notify({
          title: "Advertencia!",
          type: "danger",
          content: "Se ha presentado un cargando los sub tipos de gestión",
        });
      });
    //get informes solicitados por la persona
    this.getInformes();
  },
};
</script>
<style>
#space {
  padding-top: 10px;
}

#datepicker {
  background: white;
  padding-top: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.disponibles {
  display: flow-root !important;
}

.titulos-disponible {
  padding-left: initial !important;
  padding-right: initial !important;
}

.table thead>tr>th {
  font-size: 14px !important;
}

.table thead>tr>td {
  font-size: 10px !important;
}

.table-responsive {
  overflow: auto !important;
  width: 100%;
}
</style>
